<template>
  <v-btn
    :loading="loading"
    :type="type"
    :block="block"
    :icon="iconStyle"
    :disabled="disabled || loading"
    :variant="iconStyle ? 'text' : variant"
    :color="color"
    :class="[
      { 'my-button': !iconStyle },
      { 'box-shadow-default': !iconStyle },
      { 'icon-only': !iconStyle && iconOnly },
      { 'btn-sm': !iconStyle && size === 'sm' },
      { 'btn-icon-style': iconStyle },
      { 'btn-icon-style-sm': iconStyle && size === 'sm' },
    ]"
  >
    <template v-if="iconPosition === 'start' && computedIcon">
      <component
        :is="computedIcon"
        :class="['btn-icon', { 'mr-2': !iconOnly && !iconStyle }, { 'icon-style': iconStyle }, { 'icon-style-sm': iconStyle && size === 'sm' }]"
      />
    </template>
    <span
      :class="{
        'text-flat': variant === 'flat',
        'text-outlined': variant !== 'flat',
      }"
      >{{ $gt(buttonText) }}</span
    >
    <template v-if="iconPosition === 'end' && computedIcon">
      <component :is="computedIcon" :class="['btn-icon', 'ml-2', { 'icon-style': iconStyle }, { 'icon-style-sm': iconStyle && size === 'sm' }]" />
    </template>
  </v-btn>
</template>

<script>
import { getIcon } from "@/components/utils/utils";

export default {
  name: "ButtonBase",

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "submit",
    },
    block: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "outlined",
    },
    color: {
      type: String,
      default: "primary",
    },
    buttonText: {
      type: String,
      required: false,
    },
    icon: {
      type: Function,
      default: null,
    },
    iconType: {
      type: String,
      default: null,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    iconStyle: {
      type: Boolean,
      default: false,
    },
    iconPosition: {
      type: String,
      default: "start",
      validator: (value) => ["start", "end"].includes(value),
    },
    size: {
      type: String,
      default: "md",
      validator: (v) => ["sm", "md"].includes(v),
    },
  },

  computed: {
    computedIcon() {
      return getIcon(this.icon, this.iconType);
    },
  },
};
</script>

<style scoped>
/* Default button style */
.my-button {
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: none;
  letter-spacing: normal;
  border-radius: 8px;
  border-color: var(--border-grey-color);
  height: 40px !important;
  font-size: 0.9rem;
  font-weight: 400;
  background-color: white;
  padding-left: 16px;
  padding-right: 20px;
}

.btn-icon-style-sm {
  height: 40px !important;
  width: 40px !important;
  padding: 6px !important;
}

/* Icon only */
.my-button.icon-only {
  min-width: 48px;
  height: 40px !important;
  padding: 8px;
}

/* Icons */
.btn-icon {
  width: 20px;
  height: 20px;
  stroke-width: 1.5;
}

.btn-icon.icon-style {
  width: 24px;
  height: 24px;
  stroke-width: 1.5;
}

.btn-icon.icon-style-sm {
  width: 20px;
  height: 20px;
  stroke-width: 1.5;
}

/* Text styles */
.text-outlined {
  color: var(--dark-color);
}

.text-flat {
  color: white;
}
</style>
